import * as React from "react";
const SvgTtMailFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10 3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm0 1L7 6 4 4v1l3 2 3-2zm6 8a6 6 0 0 1 6 6v2a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-2a6 6 0 0 1 6-6m0-1a3 3 0 1 0 0-6 3 3 0 0 0 0 6", clipRule: "evenodd" }));
export default SvgTtMailFill;
